'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./~/ipld-dag-cbor/src/index.js
// module id = 535
// module chunks = 0